import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import reorderBackground from "../assets/reorderNumpad.png";

export default function Calculator({ currentQuestion, ...props }) {
  const [reverseOrder, setReverseOrder] = useState(true);
  const answer = useRef([]);
  const [displayValue, setDisplayValue] = useState("");
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
  useEffect(() => {
    window.addEventListener("keyup", downHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keyup", downHandler);
    };
  }, [displayValue]);

  let valueButtons = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  if (reverseOrder) {
    valueButtons = [7, 8, 9, 4, 5, 6, 1, 2, 3];
  }

  function submit() {
    props.onSubmitted(answer.current.join(""), (verdict, value) => {
      return new Promise(function (resolve, reject) {
        if (verdict === false) {
          setShowCorrectAnswer(true);
          setDisplayValue(value);
          setTimeout(function () {
            answer.current = [];
            setDisplayValue(answer.current);
            setShowCorrectAnswer(false);
          
            return resolve();
          }, 500);
        } else {
          answer.current = [];
          setDisplayValue(answer.current);
          return resolve();
        }
      });
    });
  }

  function downHandler({ key }) {
    switch (key) {
      case "1":
        answer.current = [...answer.current, 1];
        break;
      case "2":
        answer.current = [...answer.current, 2];
        break;
      case "3":
        answer.current = [...answer.current, 3];
        break;
      case "4":
        answer.current = [...answer.current, 4];
        break;
      case "5":
        answer.current = [...answer.current, 5];
        break;
      case "6":
        answer.current = [...answer.current, 6];
        break;
      case "7":
        answer.current = [...answer.current, 7];
        break;
      case "8":
        answer.current = [...answer.current, 8];
        break;
      case "9":
        answer.current = [...answer.current, 9];
        break;
      case "0":
        answer.current = [...answer.current, 0];
        break;
      case "Enter":
        if (answer.current.length > 0) {
          submit();
        }
        break;
      case "Backspace":
        answer.current = [];
        break;
      default:
        break;
    }
    setDisplayValue(answer.current.join(""));
  }
  console.log(currentQuestion);
  console.log("cq1:" + currentQuestion[0]);
console.log(currentQuestion);
  return (
    <CalculatorContainer>
      <CalculatorFrame>
        <Question>
          {
            currentQuestion[0] !== undefined ? currentQuestion[0].join(" ") : ""
          }
        </Question>
        {showCorrectAnswer ? (
          <CorrectAnswer type="text" disabled value={currentQuestion[1]} />
        ) : (
            <div style={{width : "100%"}}>{currentQuestion[1].toString().includes("0.") ? (
              <Answer type="text" disabled value={"0." + displayValue} style = {{width : "90%"}}/>
            ) : (
                <Answer type="text" disabled value={displayValue}  style = {{width : "90%"}}/>
              )}</div>
          )}
        <Numberpad>
          {valueButtons.map(value => (
            <CalcButton
              value={value}
              onClick={() => {
                answer.current = [...answer.current, value];
                setDisplayValue(answer.current.join(""));
              }}
            >
              {value}
            </CalcButton>
          ))}
          <CancelButton
            value={0}
            onClick={() => {
              answer.current = [];
              setDisplayValue(answer.current.join(""));
            }}
          >
            C
          </CancelButton>
          <CalcButton
            value={0}
            onClick={() => {
              answer.current = [...answer.current, 0];
              setDisplayValue(answer.current.join(""));
            }}
          >
            0
          </CalcButton>
          <OKButton
            value={0}
            onClick={() => {
              submit();
            }}
          >
            OK
          </OKButton>
        </Numberpad>
      </CalculatorFrame>
      <OrderNumpad onClick={() => setReverseOrder(!reverseOrder)} />
    </CalculatorContainer>
  );
}

const CalculatorFrame = styled.div`
  width: 500px;
  height: 600px;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  display: relative;
`;

const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Numberpad = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const OrderNumpad = styled.div`
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-image: url(${reorderBackground});
  background-size: cover;
  margin-left: 30px;
  align-self: center;
  &:hover {
    cursor: pointer;
  }
`;

const Question = styled.div`
  background: #E9E9E9;
  line-height: 35px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  user-select: none;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 20px 0px 20px;
`;

const Answer = styled.input`
  height: 70px;
  line-height: 50px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const CorrectAnswer = styled.input`
  height: 70px;
  line-height: 50px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  color: green;
`;

const CalcButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const CancelButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(234, 29, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 29, 19, 1) 0%,
    rgba(255, 60, 50, 1) 100%
  );

  border: 2px solid rgb(234, 29, 19);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const OKButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background-color: #999;
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
